import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Dropdown, Text } from '@blueprint/ui';
import { getRems } from '../../Layout/Layout.styles';
import { LSRP_SIDEBAR_MEDIA_QUERY } from 'search/common/constants';

export const SearchResultsHeaderWrapper = styled.div(
    ({ theme }) => css`
        padding: 0 ${theme.spacing['16px']};
        margin-bottom: ${theme.spacing['24px']};
        display: block;
        margin-top: -${theme.spacing['24px']};

        h1 {
            margin-bottom: ${theme.spacing['16px']};
            font-weight: ${theme.type.semiBold};
            font-size: ${theme.fontSizes[9]};
        }

        ${theme.mq.medium} {
            margin-top: 0;
        }

        ${theme.mq.large} {
            padding: 0 ${theme.spacing['32px']};
            margin-bottom: ${theme.spacing['32px']};

            h1 {
                margin: ${theme.spacing['24px']} 0;
                font-size: ${theme.fontSizes[7]};
            }
        }
    `
);

export const SearchResultsTotalText = styled(Text)(
    () => css`
        margin: auto 0;
    `
);

export const SearchResultsTotalVariant = styled(Text)(
    ({ theme }) => css`
        margin: auto 0;
        flex-basis: 100%;
        padding-top: ${theme.spacing['16px']};
        border-top: solid 1px ${theme.colors['graphic-divider']};
        border-bottom: solid 1px ${theme.colors['graphic-divider']};
        padding-bottom: ${theme.spacing['16px']};

        ${theme.mq.large} {
            border-top-color: transparent;
            border-bottom: transparent;
        }
    `
);

export const Footer = styled.div(
    ({ theme }) => css`
        display: block;

        ${theme.mq.small} {
            display: flex;
            width: 100%;
        }
    `
);

export const SortOrderDropdownStyle = styled(Dropdown)(
    ({ theme }) => css`
        ${theme.mq.small} {
            width: ${getRems(180)};
        }

        ${theme.mq.large} {
            margin-left: ${theme.spacing['32px']};
        }
    `
);

export const FooterCell = styled.div(
    ({ theme }) => css`
        flex-grow: 1;
        display: flex;
        height: ${getRems(54)};

        > * {
            margin-top: auto;
            margin-bottom: auto;
        }

        &:first-of-type {
            display: flex;
            justify-content: space-between;
            margin-bottom: ${theme.spacing['24px']};
            margin-bottom: 0;

            ${theme.mq.small} {
                justify-content: flex-start;
            }
        }

        &:last-of-type {
            justify-content: flex-end;
            display: none;

            ${theme.mq.large} {
                display: flex;
            }
        }
    `
);

export const BreadcrumbsPlaceholder = styled.div(
    ({ theme }) => css`
        height: ${getRems(23)};
        line-height: ${getRems(23)};
        color: ${theme.colors['text-placeholder']};
        font-size: ${getRems(14)};
    `
);

export const Divider = styled('span')(
    ({ theme }) => css`
        width: 0.0625rem;
        height: 1.375rem;
        background-color: ${theme.colors['graphic-divider']};
        display: none;
        margin: 0 ${theme.spacing['24px']} 0 ${theme.spacing['16px']};
        align-self: center;
        display: inline-block;
    `
);

export const SmallerScreenSaveSearch = styled('div')(
    () => css`
        display: block;

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: none;
        }
    `
);

export const BreadcrumbsShowDesktopWrapper = styled.div(
    ({ theme }) => css`
        display: none;

        ${theme.mq.large} {
            display: initial;
        }
    `
);
